module.exports = __webpack_public_path__ + "static/media/resep_rahasia.c52a44ba.jpeg";